import React, { useEffect, useState } from "react";
import { Link, Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { useApp } from "../contexts/AppContext";
import { subscribeUserFavoriteIds } from "../services/analytics";
import { listAll, listCategoriesTree } from "../services/firestore";
import ProductCard from "../components/ProductCard";

export default function FavoritesPage() {
  const { user, authChecked } = useAuth();
  const { t } = useApp();
  const [favIds, setFavIds] = useState([]);
  const [products, setProducts] = useState([]);
  const [artists, setArtists] = useState([]);

  useEffect(() => {
    if (!user) return;
    return subscribeUserFavoriteIds(user.uid, setFavIds);
  }, [user]);

  useEffect(() => {
    Promise.all([listAll("products"), listAll("artists")]).then(([p, a]) => {
      setProducts(p); setArtists(a);
    });
  }, []);

  if (!authChecked) return <div className="min-h-[60vh] flex items-center justify-center text-[var(--text-2)]">{t.common.loading}</div>;
  if (!user) return <Navigate to="/login?next=/favorites" replace />;

  const artistById = Object.fromEntries(artists.map((a) => [a.id, a]));
  const items = products.filter((p) => favIds.includes(p.id));

  return (
    <div className="max-w-screen-2xl mx-auto px-6 md:px-12 py-16" data-testid="favorites-page">
      <div className="eyebrow mb-3">{t.common.account}</div>
      <h1 className="section-title text-5xl md:text-7xl">{t.fav.title}</h1>

      {items.length === 0 ? (
        <div className="mt-16 text-[var(--text-2)] text-center py-20 border border-[var(--border)]">
          <div className="metadata">{t.fav.empty}</div>
          <Link to="/catalog" className="btn-outline mt-6 inline-flex">{t.common.continueShopping}</Link>
        </div>
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8 mt-12">
          {items.map((p) => <ProductCard key={p.id} product={p} artistName={artistById[p.artist_id]?.name} artistSlug={artistById[p.artist_id]?.slug} artistId={p.artist_id} />)}
        </div>
      )}
    </div>
  );
}
